// @flow
import * as React from "react";

import { Field } from "redux-form";
import { FormRadio, FormSelect } from "../../../../../components";

import { getClassicLeagueFinalFormat, league_tooltips } from "../../../../../helpers";

type Props = {
	is_finals: boolean,
	league_size: number,
	league: {
		status: string,
	}
};

export const AdvancedLeagueSettings = ({ is_finals, league_size, league }: Props) => (
	<div>
		<FormRadio
			label='League finals series'
			name='finals'
			elements={[
				{
					value: 1,
					text: "Yes",
				},
				{
					value: 0,
					text: "No",
				}
			]}
			tooltip={league_tooltips.finals}
			is_disabled={league.status !== "scheduled"}
		/>

		<Field
			label='League finals format'
			name='finals_format'
			options={getClassicLeagueFinalFormat({ league_size })}
			component={FormSelect}
			tooltip={league_tooltips.finals_format}
			is_disabled={!is_finals || league.status !== "scheduled"}
		/>

		<Field
			label='Play opponents'
			name='play_times'
			options={[
				{
					value: "flexible",
					text: "Flexible",
				},
				{
					value: "once",
					text: "Once",
				},
				{
					value: "twice",
					text: "Twice",
				},
			]}
			component={FormSelect}
			tooltip={league_tooltips.play_times}
			is_disabled={league.status !== "scheduled"}
		/>

		<FormRadio
			label='Bye rounds'
			name='bye_rounds'
			elements={[
				{
					value: 1,
					text: "On",
				},
				{
					value: 0,
					text: "Off",
				}
			]}
			tooltip={league_tooltips.bye_rounds}
		/>

		<FormRadio
			label='Ladder Tiebreaker'
			name='rank_by'
			is_string_value={true}
			elements={[
				{
					value: "percentage",
					text: "Percentage",
				},
				{
					value: "points_for",
					text: "Points For",
				}
			]}
			tooltip={league_tooltips.ladder_tiebreaker}
			is_disabled={league.status !== "scheduled"}
		/>
	</div>
);

export default AdvancedLeagueSettings;